var heroWhyObserver = {
    init: function () {
        const whyVideoWrapper = document.getElementById('whyVideoWrapper');
        if (whyVideoWrapper) {
            let intersectionOptions = {
                threshold: [0, 0.5]
            }
            if (typeof window.IntersectionObserver !== 'undefined') {
                function whyVideoWrapperIntersection(entries) {
                    entries.map((entry) => {
                        if (entry.intersectionRatio > 0.49) {
                            const player = document.getElementById('whyPlayer');
                            player.style.transition = '1.2s ease';
                            player.style.transform = 'scale(1, 1)';
                            observer.unobserve(entry.target);
                        }
                    });
                }

                const observer = new IntersectionObserver(whyVideoWrapperIntersection, intersectionOptions);
                observer.observe(whyVideoWrapper);
            }
        } else {
            const player = document.getElementById('whyPlayer');
            if (player)
                player.style.transform = 'scale(1, 1)';
        }
    }
}

export default heroWhyObserver;